<template>
  <div class="slide">
    <em class="slide-ico"></em>
    <div class="slide-container" ref="container">
      <div class="slide-container-move" ref="move">
        <p class="pre" ref="pre">{{ tip }}</p>
        <p class="after" v-show="showAfterTip" ref="after">{{ tip }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlideTipBar',
  props: {
    tip: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      showAfterTip: false
    }
  },
  methods: {
    slideTip() {
      const containerWidth = this.$refs.container.clientWidth;
      const tipWidth = this.$refs.pre.clientWidth;
      // 如果文字宽度小于容器宽度，则不进行滚动
      if(tipWidth <= containerWidth) {
        return;
      }
      this.showAfterTip = true;
      let slideX = 0;
      const ani = () => {
        this.$refs.move.style = `transform: translate3d(-${slideX}px, 0, 0)`;
        slideX++;
        if(slideX == tipWidth) {
          this.$refs.move.style = `transform: translate3d(-0px, 0, 0)`;
          slideX = 0;
        }
        window.requestAnimationFrame(ani);
      }
      ani();
    },
  },
  mounted() {
    this.slideTip();
  },
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.slide {
  display: flex;
  justify-content: center;
  align-items: center;
  &-ico {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    @psetbg ("typeall.png");
  }
  &-container {
    position: relative;
    overflow: hidden;
    width: 500px;
    height: 26px;
    margin-left: 8px;
    line-height: 26px;
    mask: linear-gradient(90deg, #fff 0%, #fff 80%, transparent 100%);
    &-move {
      height: 100%;
      text-align: left;
      white-space: nowrap;
      .pre,
      .after {
        display: inline-block;
        font-size: 26px;
        color: #fff;
      }
    }
  }
}
</style>
